<template>
    <div>
        <div class="row fs-18" v-if="data.mainPhone">
            <div
                class="col-12 fs-24 mb-2"
            >
                <h3 :class="{'title-footer': templateId == 2}">Contáctanos:</h3>
            </div>

            <div class="col-12 mb-2">
                <i class="fe-phone-call fs-20 mr-2"></i> {{ data.mainPhone | phoneFilter }}
            </div>

            <div class="col-12 mb-2" v-if="data.secondaryPhone">
                <i class="fe-phone-call fs-20 mr-2"></i> {{ data.secondaryPhone | phoneFilter }}
            </div>

            <div class="col-12 mb-2" v-if="data.contactEmail">
                <i class="fe-mail fs-20 mr-2"></i> {{ data.contactEmail }}
            </div>

            <div class="col-12" v-if="data.address">
                <i class="fe-map-pin fs-20 mr-2"></i> {{ data.address }}
            </div>
        </div>

        <div class="row mt-4" v-if="data.facebook || data.instagram || data.twitter || data.youtube || data.linkedin">
            <div class="col-12 fs-24 mb-2">
                <strong>Síganos:</strong>
            </div>

            <div class="col-12 fs-24">
                <a class="a-white-s" :href="data.facebook" target="_blank" v-if="data.facebook"><i class="fe-facebook mr-2"></i></a>
                <a class="a-white-s" :href="data.instagram" target="_blank" v-if="data.instagram"><i class="fe-instagram mr-3"></i></a>
                <a class="a-white-s" :href="data.twitter" target="_blank" v-if="data.twitter"><i class="fe-twitter mr-3"></i></a>
                <a class="a-white-s" :href="data.youtube" target="_blank" v-if="data.youtube"><i class="fe-youtube mr-3"></i></a>
                <a class="a-white-s" :href="data.linkedin" target="_blank" v-if="data.linkedin"><i class="fe-linkedin"></i></a>
            </div>
        </div>
    </div>
</template>

<script>
import filtersMixin from '../../../mixins/filtersMixin';

export default {

    mixins: [
        filtersMixin,
    ],

    props: {
        data: {
            type: Object,
            required: true,
        },
        templateId: {
            type: Number,
            default: 1,
        },
    },

};
</script>
